<app-gallery-settings-customize-header
  title="Typography"
  location="theme-typography-customize"
  (back)="back.emit()"
></app-gallery-settings-customize-header>

<div class="togglers">
  <app-theme-cover-title-item
    [gallery]="gallery()"
    [theme]="theme()"
    [open]="openToggler() === 'coverTitle'"
    (onOpen)="openToggler.set('coverTitle')"
    (onClose)="openToggler.set(undefined)"
  ></app-theme-cover-title-item>
  <app-theme-cover-description-item
    [gallery]="gallery()"
    [theme]="theme()"
    [open]="openToggler() === 'coverDescription'"
    (onOpen)="openToggler.set('coverDescription')"
    (onClose)="openToggler.set(undefined)"
  ></app-theme-cover-description-item>
  <app-theme-headings-item
    [gallery]="gallery()"
    [theme]="theme()"
    [open]="openToggler() === 'headings'"
    (onOpen)="openToggler.set('headings')"
    (onClose)="openToggler.set(undefined)"
  ></app-theme-headings-item>
  <app-theme-paragraphs-item
    [gallery]="gallery()"
    [theme]="theme()"
    [open]="openToggler() === 'paragraphs'"
    (onOpen)="openToggler.set('paragraphs')"
    (onClose)="openToggler.set(undefined)"
  ></app-theme-paragraphs-item>
</div>
